import { Combobox } from '@reach/combobox';
import PropTypes from 'prop-types';
import * as React from 'react';
import warning from 'tiny-warning';
import { filterProps } from '../core/core.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { processStyleProps } from '../core/swan-style.js';
import { ComboboxInput } from './combobox-input.component.js';
import { ComboboxList } from './combobox-list.component.js';
import { ComboboxPopover } from './combobox-popover.component.js';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
({
  inModal: PropTypes.bool
});
const BasicCombobox = renderWithRef('BasicCombobox', undefined, (props, ref) => {
  const {
    as,
    component,
    onSelect,
    openOnFocus,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    children,
    className
  } = props;
  const processedClassName = Array.from(processStyleProps(props, className ? [className] : undefined)).join(' ');
  const filteredProps = filterProps(props, ['onSelect', 'openOnFocus', 'aria-label', 'aria-labelledby', 'inModal']);
  warning(as === undefined && component === undefined, 'props `as` and `component` not supported as BasicCombobox uses 3rd party lib');
  return /*#__PURE__*/React.createElement(Combobox, {
    onSelect: onSelect,
    openOnFocus: openOnFocus,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: processedClassName
  }, /*#__PURE__*/React.createElement(ComboboxInput, _extends({
    ref: ref
  }, filteredProps, {
    className: undefined
  })), /*#__PURE__*/React.createElement(ComboboxPopover, {
    inModal: props.inModal
  }, /*#__PURE__*/React.createElement(ComboboxList, null, children)));
});
export { BasicCombobox };